import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-advisor-card',
    templateUrl: './advisor-card.component.html',
    styleUrls: ['./advisor-card.component.scss'],
    imports: [RouterModule,CommonModule]
})
export class AdvisorCardComponent implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }

}
